// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7fbd8fcb","703":"5673ce6d"}[chunkId] + ".chunk.js";
};